// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_xiaozhu@2022.4.8@xiaozhu/wechatapp/css/global.css
// module id = 89
// module chunks = 49